import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import withStyles from "@material-ui/core/styles/withStyles";
import CssBaseline from "@material-ui/core/CssBaseline";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import CircularProgress from "@material-ui/core/CircularProgress";
import InputLabel from "@material-ui/core/InputLabel";

const styles = theme => ({
	formControl: {
		margin: 10
	}
});
class DropSelect extends Component {
	constructor() {
		super();
		this.state = {
			formControl: {
				width: 500
			}
		};
	}

	handleChange = event => {
		const { onChange } = this.props;
		this.setState({ [event.target.name]: event.target.value });
		onChange(event);
	};

	render() {
		const {
			classes,
			label,
			id,
			name,
			placeholder,
			items, // Receives array of strings or objects, where (value: any, label: string )
			width
		} = this.props;
		return (
			<div>
				<CssBaseline />
				<FormControl variant="outlined" className={classes.formControl}>
					<InputLabel
						htmlFor={id}
						ref={ref => {
							this.labelRef = ReactDOM.findDOMNode(ref);
						}}
					>
						{label}
					</InputLabel>
					<Select
						id={id}
						value={this.state[name] ? this.state[name] : ""}
						onChange={this.handleChange}
						style={{ width: width ? width : 500 }}
						label="With outlined TextField"
						input={
							<OutlinedInput
								labelWidth={this.labelRef ? this.labelRef.offsetWidth : 50}
								name={name}
								placeholder={placeholder}
							/>
						}
					>
						<MenuItem value="">
							<em>Select one</em>
						</MenuItem>
						{items ? (
							typeof items[0] === "object" ? (
								items.map((item, index) => {
									return (
										<MenuItem key={index} value={item.value}>
											{item.label}
										</MenuItem>
									);
								})
							) : (
								items.map((item, index) => {
									return (
										<MenuItem key={index} value={item}>
											{item}
										</MenuItem>
									);
								})
							)
						) : (
							<CircularProgress />
						)}
					</Select>
				</FormControl>
			</div>
		);
	}
}

DropSelect.propTypes = {
	classes: PropTypes.any.isRequired,
	id: PropTypes.string.isRequired,
	items: PropTypes.array.isRequired, // label && value of just items
	onChange: PropTypes.func.isRequired,
	value: PropTypes.any
};

export default withStyles(styles)(DropSelect);
